export default "__VITE_ASSET__BsG1zr5S__"